module.exports = __webpack_public_path__ + "img/Form.4a0c1285.svg";